<template>
    <form @submit.prevent="submit">
        <div class="modal-card" style="overflow: initial">
            <header class="modal-card-head">
                <p class="modal-card-title">Create Tag</p>
            </header>
            <section class="modal-card-body" style="overflow: initial">
                <b-field label="Name">
                    <b-input type="text" v-model="data.name"></b-input>
                </b-field>

                <b-field label="Type" v-if="isAdmin">
                    <!-- <b-input type="text" v-model="data.type"></b-input> -->
                    <base-combobox
                        :value.sync="data.type"
                        :service="$options.tagService"
                        fetch-func="listTypes"
                        :fetch-params="{ firm_id: organization ? organization.id : undefined }"
                        fetch-on-init
                        label-key="type"
                        allow-new
                    />
                </b-field>
            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" @click="$parent.close()">Close</button>
                <button class="button is-primary" :disabled="loading">Create</button>
            </footer>
        </div>
    </form>
</template>

<script>
import BaseCombobox from "@/components/partials/BaseCombobox";
import { FirmService } from "@/services/firm.service";
import { TagService } from "@/services/tag.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

export default {
    tagService: TagService,
    props: {
        organization: {
            type: Object
        }
    },
    components: {
        BaseCombobox,
    },
    data: () => ({
        loading: false,
        data: {
            name: null,
            type: "",
            // type: null
        }
    }),
    computed: {
        isAdmin() {
            return this.$store.getters["Auth/hasRole"]("admin");
        },
    },
    methods: {
        async submit() {
            try {
                this.loading = true;

                let tag = null;

                // if (this.organization) {
                //     tag = await FirmService.createTag(this.organization.id, this.data).then(response => JsonDenormalizer.denormalize(response));
                // } else {
                    tag = await this.$options.tagService
                        .store({
                            ...this.data,
                            firm_id: this.organization ? this.organization.id : undefined,
                        })
                        .then(response => JsonDenormalizer.denormalize(response));
                // }

                this.$emit("newTag", tag);
                this.$parent.close();
            } catch (err) {
                console.log(err)
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/Tags/list/partials/createTagModal.vue